import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { PageTitle } from "@/components/app/ui";
import { api, errMsg } from "@/lib/api";

const KeyForm = ({ mode, cfg, onSaved }) => {
  const [f, setF] = useState({ key_id: cfg.key_id, key_secret: "" });
  const save = async (e) => {
    e.preventDefault();
    try { await api.put("/admin/settings/razorpay", { mode, ...f }); toast.success(`${mode} keys saved`); onSaved(); } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <form onSubmit={save} className="card-box p-6 space-y-4" data-testid={`rp-form-${mode}`}>
      <h3 className="font-semibold capitalize">{mode} account {mode === "live" ? "· customer payments" : "· admin test purchases"}</h3>
      <div className="space-y-2"><Label>Key ID</Label><Input value={f.key_id} onChange={(e) => setF({ ...f, key_id: e.target.value })} placeholder={`rzp_${mode}_xxxxx`} data-testid={`rp-${mode}-key-id`} /></div>
      <div className="space-y-2"><Label>Key secret {cfg.key_secret_masked && <span className="text-muted-foreground">(saved: {cfg.key_secret_masked})</span>}</Label><Input type="password" value={f.key_secret} onChange={(e) => setF({ ...f, key_secret: e.target.value })} placeholder="Leave blank to keep" data-testid={`rp-${mode}-key-secret`} /></div>
      <div className="flex items-center justify-between"><span className="text-sm" data-testid={`rp-${mode}-status`}>{cfg.enabled ? "Enabled" : "Not configured"}</span><button className="btn-brand !py-2" data-testid={`rp-${mode}-save`}>Save {mode} keys</button></div>
    </form>
  );
};

export default function AdminSettings() {
  const [rp, setRp] = useState(null);
  const [logs, setLogs] = useState([]);
  const [social, setSocial] = useState(null);
  const load = () => api.get("/admin/settings/razorpay").then((r) => setRp(r.data));
  useEffect(() => { load(); api.get("/admin/audit-logs").then((r) => setLogs(r.data)); api.get("/admin/settings/social").then((r) => setSocial(r.data)); }, []);
  return (
    <div data-testid="admin-settings-page">
      <PageTitle title="Payment keys & audit logs" copy="Live keys are used for all customer payments. Test keys are used only when the admin (chandra@sliance.com) checks out. Enable International Payments in Razorpay for USD/EUR/GBP/AED." />
      <div className="grid lg:grid-cols-2 gap-6">
        {rp && <KeyForm mode="live" cfg={rp.live} onSaved={load} />}
        {rp && <KeyForm mode="test" cfg={rp.test} onSaved={load} />}
      </div>
      <h3 className="mt-10 mb-4 text-xl font-semibold">Social publishing apps</h3>
      <div className="card-box p-6 grid md:grid-cols-2 gap-4 text-sm" data-testid="social-status">
        {social && Object.entries(social).map(([p, v]) => (
          <div key={p} className="rounded-xl border p-4"><div className="font-semibold capitalize">{{ meta: "Meta (Facebook + Instagram)", linkedin: "LinkedIn", x: "X (Twitter)" }[p]}: <span className={v.ready ? "text-[#10b981]" : "text-[#f59e0b]"}>{v.ready ? "Live ready" : "Keys missing"}</span></div>
            <div className="mt-2 text-xs text-muted-foreground break-all">Redirect URI to register: {v.redirect_uri}</div></div>
        ))}
        <p className="md:col-span-2 text-xs text-muted-foreground">Add LINKEDIN_CLIENT_ID / LINKEDIN_CLIENT_SECRET and META_APP_ID / META_APP_SECRET and X_CLIENT_ID / X_CLIENT_SECRET (X API Basic tier or higher required for posting) to the backend environment to enable live posting.</p>
      </div>
      <h3 className="mt-10 mb-4 text-xl font-semibold">Audit log</h3>
      <div className="card-box overflow-x-auto">
        <Table data-testid="audit-table">
          <TableHeader><TableRow><TableHead>Time</TableHead><TableHead>User</TableHead><TableHead>Action</TableHead><TableHead>Entity</TableHead></TableRow></TableHeader>
          <TableBody>{logs.map((l) => (
            <TableRow key={l.id}><TableCell className="text-xs">{new Date(l.created_at).toLocaleString()}</TableCell><TableCell className="text-xs">{l.user_email}</TableCell><TableCell className="font-mono text-xs">{l.action}</TableCell><TableCell className="text-xs truncate max-w-[220px]">{l.entity}</TableCell></TableRow>
          ))}</TableBody>
        </Table>
      </div>
    </div>
  );
}
